<template>
  <div v-if="can('edit-role')">
    <h2>Edit Role</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="name">Name<Astrik /></label>
              <input
                type="text"
                v-model="form.name"
                class="form-control"
                id="name"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="guard_name"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="guard_name">Guard Name</label>
              <input
                type="text"
                v-model="form.guard_name"
                class="form-control"
                id="guard_name"
                disabled
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Update</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'RoleList',
              }"
              >Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditRole",
  data() {
    return {
      submitting: false,
      form: [],
    };
  },
  mounted() {
    // if (this.can("edit-role")) {
    this.getSingleRoleDetail();
    // } else {
    //   this.$router.push({ name: "Dashboard" });
    // }
  },
  methods: {
    getSingleRoleDetail() {
      this.$http.get("role/" + this.$route.params.id).then((res) => {
        this.form = res.data.data;
      });
    },
    submit() {
      this.submitting = true;
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("name", this.form.name);
      formData.append("guard_name", this.form.guard_name);

      this.$http
        .post("role/" + this.$route.params.id, formData)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Service",
              type: "success",
              text: res.data.message,
            });
            this.$router.push({ name: "RoleList" });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
